var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-fx ai-c"},[_c('i',{staticClass:"icon-bell f-20px mt-_2px cursor-pointer",on:{"click":_vm.toggleNotification}}),_c('i',{staticClass:"icon-search f-22px mt-_2px ml-10px cursor-pointer",on:{"click":_vm.toggleSearch}})])}
var staticRenderFns = []

export { render, staticRenderFns }